import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { FunctionComponent, useEffect, useState } from 'react';
import arrowRight from '../../assets/svgs/arrow-right.svg';
import tick from '../../assets/svgs/tick.svg';
import { useAuthDispatch, useAuthStore } from '../../store/AuthStore';
import { ActionType } from '../../store/StoreTypes';
import { colors } from '../../theme/colors';

const useStyles = makeStyles(() => ({
  root: {
    backdropFilter: 'blur(3px)',
    '& .MuiPaper-root': {
      width: 592,
      borderRadius: 30,
      boxShadow: '-2px -2px 8px rgba(0, 0, 0, 0.1), 6px 6px 8px rgba(0, 0, 0, 0.1)',
      backgroundColor: colors.xLightGray,
      paddingBottom: 55,
      paddingTop: 20,
    },
    '& .MuiBackdrop-root': {
      backgroundColor: 'transparent',
    },
    '& .MuiTypography-root': {
      color: colors.black,
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'Center',
    },
  },
  dialogTextRoot: {
    marginBottom: '20px',
    marginTop: '10px',
    maxWidth: '250px',
    textAlign: 'center',
  },
}));

export const EmailVerifiedModal: FunctionComponent = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const dispatch = useAuthDispatch();
  const showEmailVerifiedModal = useAuthStore((state) => state.userStatus.firstTimeVisit);

  useEffect(
    function toggleModal() {
      showEmailVerifiedModal ? setOpen(true) : setOpen(false);
    },
    [showEmailVerifiedModal]
  );

  function handleClose() {
    dispatch({
      type: ActionType.SET_USER_STATUS,
      userStatus: { firstTimeVisit: false },
    });
    setOpen(false);
  }

  return (
    <div>
      <Dialog
        open={open}
        classes={{ root: classes.root }}
        data-testid="email-verified-modal"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description-one alert-dialog-description-two"
      >
        <DialogContent>
          <Box
            textAlign="center"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Box marginBottom="30px">
              <img src={tick} width={85} height={85} alt="email is verified" />
            </Box>

            <Typography variant="h4">
              <Box fontWeight={500} id="alert-dialog-title">
                Email verified
              </Box>
            </Typography>
          </Box>
          <Box
            textAlign="center"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <DialogContentText
              id="alert-dialog-description-one"
              classes={{ root: classes.dialogTextRoot }}
            >
              Great! You can now access all Mindset Health programs, and consider them for
              your&nbsp;patients.
            </DialogContentText>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box width={160} textAlign="center" display="flex" justifyContent="center">
            <Button
              onClick={handleClose}
              variant="contained"
              color="primary"
              size="small"
              fullWidth
              endIcon={
                <img
                  src={arrowRight}
                  width={20}
                  height={20}
                  alt="resend email verification arrowå"
                />
              }
            >
              Start
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
};
